module.exports = __webpack_public_path__ + "static/media/logout-svgrepo-com.5b765a21.png";